import { Box, Typography } from "@mui/material";
import { tabs } from "./data";
import { useState } from "react";
import TabBar from "./tabs/booking-details/components/TabBar";
import BookingDetails from "./tabs/booking-details/BookingDetails";
import ProposalTab from "./tabs/proposals/Proposals";
import { useBookingData } from "../view-booking/hooks/UseBookingData";

import BookingAudit from "./tabs/audit/BookingAudit";
import MemoryTableTab from "./tabs/memory-table/MemoryTableTab";
import ClientReviewTab from "./tabs/client-review/ClientReview";

export default function ViewBookingPage2() {
  const [activeTab, setActiveTab] = useState(0);
  const { bookingData } = useBookingData();

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <BookingDetails />;
      case 1:
        return <ProposalTab bookingData={bookingData} />;
      case 2:
        return <MemoryTableTab bookingData={bookingData} />;
      // case 3:
      //   return <Typography>Chema Coming Soon</Typography>;
      // case 4:
      //   return <GraphicsTab bookingData={bookingData} />;
      case 3:
        return bookingData ? (
          <ClientReviewTab bookingId={bookingData.id.toString()} />
        ) : (
          <Typography>Loading review...</Typography>
        );
      case 4:
        return bookingData ? (
          <BookingAudit bookingId={bookingData.id.toString()} />
        ) : (
          <Typography>Loading audit history...</Typography>
        );
      default:
        return <Typography>Audit soon</Typography>;
    }
  };

  return (
    <Box>
      <TabBar tabs={tabs} activeIndex={activeTab} onChange={setActiveTab} />
      {renderTabContent()}
    </Box>
  );
}
